package com.wintermar.inspection.feature.domain.usecase.answer

import com.wintermar.inspection.core.domain.Result
import com.wintermar.inspection.core.ui.component.image.util.FileUploadStatus
import com.wintermar.inspection.feature.domain.model.answer.AnswerModel
import com.wintermar.inspection.feature.domain.repository.answer.AnswerRepository

class GetPendingUploadFilesUseCase(
    private val answerRepository: AnswerRepository
) {
    suspend operator fun invoke(statuses: List<FileUploadStatus>): Result<List<AnswerModel>> {
        return answerRepository.getFileByStatuses(statuses)
    }
}
